import { DownOutlined } from '@ant-design/icons';
import './QuestionReport.scss'
import profilePhoto from '../../../../assets/img/Female16.png';
import { useState } from 'react';
import { EmojiYellow, EmojiGreen, EmojiOrange, EmojiRed } from '../../../../assets/img/svg/icons/Icons.js';

function QuestionReport({ name, totalAverage, trainingEvalScore }) {
    
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="question-report">
            <div className="question-report-shown">
                <div className="participant-info">
                    <div className="circular-image-container">
                        <img src={profilePhoto} alt="aa" className="circular-image" />
                    </div>
                    <label>{name}</label>
                </div>
                <div className="participant-review">
                    <div className="participant-review-satisfaction">
                        {
                            totalAverage <= 25 ? <label>Unsatisfied</label>
                                : totalAverage <= 50 ? <label>Ok</label>
                                    : totalAverage <= 75 ? <label>Satisfied</label>
                                        : <label>Very satisfied</label>
                        }
                    </div>
                    <div className="participant-review-emoji">
                        {
                            totalAverage <= 25 ? <EmojiRed /> 
                                : totalAverage <= 50 ? <EmojiOrange /> 
                                    : totalAverage <= 75 ? <EmojiYellow />
                                        : <EmojiGreen />
                        }
                        <label>{totalAverage}% </label>
                    </div>
                    <div className="down-arrow" onClick={toggleOpen}>
                        <DownOutlined />
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className="question-report-hidden">
                    <div className="hidden-content">
                        {trainingEvalScore.map((question, index) => (
                            <div key={index}>
                                <div className="hidden-content-question">
                                    <label>{question.question}</label>
                                    <div className="hidden-content-emoji">
                                        {
                                            question.score === 25 ? <EmojiRed />
                                                : question.score === 50 ? <EmojiOrange />
                                                    : question.score === 75 ? <EmojiYellow />
                                                        : <EmojiGreen />
                                        }
                                        {/* <label>{question.score}</label> */}
                                    </div>
                                </div>
                                <hr />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default QuestionReport;
